import React from 'react';
import { Loader } from '@uplift/ui-v2';
import { VideoCallDrawerContentContainer } from '../../Layout';
import { TimeRange } from '@uplift/types';
import { UpcomingAppointments } from './UpcomingAppointments.component';
import { AvailabilityReview } from './AvailabilityReview.component';
import { SessionDetails } from './SessionDetails.component';


export type InCallSchedulerProps = {
  patientId: string;
  appointmentId: string;
  onClose: () => void;
  initialDate?: string;
  skipToSessionDetails?: boolean;
  onExitToOrigin?: () => void;
};


export const InCallScheduler: React.VFC<InCallSchedulerProps> = (props) => {
  const [ eventRange, setEventRange ] = React.useState<TimeRange | null>(null);
  const [ step, setStep ] = React.useState<'upcomingSessions' | 'availabilityReview' | 'sessionDetails'>(props.skipToSessionDetails ? 'availabilityReview' : 'upcomingSessions');
  const [ sessionDetailsFromAutoAdvance, setSessionDetailsFromAutoAdvance ] = React.useState(false);

  switch (step) {
    case 'upcomingSessions':
      return (
        <VideoCallDrawerContentContainer onClose={props.onClose} title="Upcoming Sessions">
          <React.Suspense fallback={<Loader color="secondary" height="300px" />}>
            <UpcomingAppointments
              patientId={props.patientId}
              appointmentId={props.appointmentId}
              onScheduleSession={() => {
                setStep('availabilityReview');
              }}
            />
          </React.Suspense>
        </VideoCallDrawerContentContainer>
      );
    case 'availabilityReview':
      return (
        <VideoCallDrawerContentContainer onClose={props.onClose} title="Review availability">
          <AvailabilityReview
            date={eventRange?.start ?? props.initialDate}
            autoAdvance={props.skipToSessionDetails && !eventRange}
            onBack={() => {
              setStep('upcomingSessions');
              setEventRange(null);
            }}
            onSessionDetails={(range, isAutoAdvance) => {
              setEventRange(range);
              setSessionDetailsFromAutoAdvance(isAutoAdvance);
              setStep('sessionDetails');
            }}
          />
        </VideoCallDrawerContentContainer>
      );
    case 'sessionDetails':
      if (!eventRange) {
        return (
          <VideoCallDrawerContentContainer onClose={props.onClose} title="Session details">
            No event range selected
          </VideoCallDrawerContentContainer>
        );
      }
      return (
        <VideoCallDrawerContentContainer onClose={props.onClose} title="Session details">
          <SessionDetails
            patientId={props.patientId}
            eventRange={eventRange}
            onBack={() => {
              if (sessionDetailsFromAutoAdvance) {
                if (props.onExitToOrigin) {
                  props.onExitToOrigin();
                } else {
                  props.onClose();
                }
                return;
              }
              setStep('availabilityReview');
            }}
            onSuccess={async () => {
              setStep('upcomingSessions');
              setEventRange(null);
            }}
          />
        </VideoCallDrawerContentContainer>
      );
  }

  return (
    <VideoCallDrawerContentContainer onClose={props.onClose} title="Unknown step">
      Unknown step
    </VideoCallDrawerContentContainer>
  );
};
